
import {
  defaultClient as apolloClient,
} from '@/plugins/vue-apollo';
import { isBulkTransactionsEnabled } from '@/utils/bulkTransactionsHelper';
import {
  GET_GROUP_BUDGET_LIST_GQL,
  GROUP_BUDGET_INSERT_GQL,
  GROUP_BUDGET_UPDATE_GQL,
  EMPLOYEE_TO_CATEGORY_GQL,
  EMPLOYEEBUDGET_INSERT_GQL,
  EMPLOYEEBUDGET_UPDATE_GQL,
  EMPLOYEEBUDGET_DELETE_GQL,
  CATEGORY_BUDGET_INSERT_GQL,
  CATEGORY_UPDATE_GQL,
  CATEGORY_BUDGET_UPDATE_GQL,
  CHECK_CURRENT_MONTH_GROUP_BUDGET_GQL,
  CATEGORY_INSERT_GQL,
  CHECK_CURRENT_MONTH_CATEGORY_BUDGET_GQL,
  CHECK_CURRENT_MONTH_USER_BUDGET_GQL,
  GET_ALL_BUDGET_DETAIL_FOR_CURRENTMONTH_GQL,
  GET_MY_BUDGET_DETAIL_FOR_CURRENTMONTH_GQL,
  GET_USER_BUDGET_FOR_CURRENTMONTH_GQL,
  REQUEST_MORE_BUDGET_GQL,
  GET_USER_LEDGER_BALANCE_GQL,
  ACTIVATE_USER_GQL,
  SET_CATEGORY_NAME_GQL,
  GET_COMPANY_CALCULATION_GQL,
  CATEGORY_COMPANY_INSERT_GQL,
  GET_COMPANY_BUDGET,
  UPDATE_COMPANY_BUDGET,
  GET_TEAM_USER,
  GET_USER_ACTUAL_BUDGET,
  GET_TEAM_WISE_EXPENSE_USER,
  GET_USER_DEFINE_BUDGET,
  UPDATE_USERDEFINE_BUDGET,
  UPDATE_CATEGORY_STATUS,
} from '@/graphql/budgets.gql';

import {
  GET_USER_GROUP_CATEGORIES_GQL,
  GET_TEAM_USERS_GQL,
  GET_USERS_CALCULATION_GQL,
  GET_COMPANY_CATEGORY_LIST_GQL,
} from '@/graphql/queries.gql';


export default {
  namespaced: true,

  state: {
    groupBudgetList: [],
    groupBudgetListTime: '',
    myBudgetDetail: [],
    allBudgetDetail: [],
    groupBudgetCreated: null,
    groupBudgetUpdated: null,
    userBudgetCreated: null,
    userBudgetUpdated: null,
    removedUserFromCategory: null,
    categoryBudgetCreated: null,
    categoryBudgetUpdated: null,
    categoryCreated: null,
    categoryUpdated: null,
    currentMonthGroupBudget: null,
    currentMonthCategoryBudget: null,
    categoryBudgetForEditcaseCreated: null,
    currentMonthUserBudget: null,
    userBudgetForEditcaseCreated: null,
    requestMoreBudgetCreated: null,
    userActivated: null,
    getAllocatedGroupBudget: [],
    getUserAllocatedBudget: [],
    userCategoryBudget: [],
    getallUserbudget: [],
    getmyUserBudget: [],
    groupAllocateBudget: [],
    teamWiseUserList: null,
    userWiseBudgetAllocation: [],
    userWiseBudgetAllocationTime: null,
    compneyCredit: null,
    companyCategoryList: [],
    isCategoryNameSet: null,
    isTeamNameSet: null,
    companyCategoriesid: null,
    setAllTeamUser: null,
    setMonthwiseUsers: [],
    setOriginalBudget: [],
    userDefineBudget: null,
    setCategoryStatus: null,
  },

  mutations: {
    SET_CATEGORY_STATUS(state, payload) {
      state.setCategoryStatus = payload;
    },
    SET_USER_DEFINE_BUDGET(state, payload) {
      state.userDefineBudget = payload;
    },
    SET_USER_TEAM_WISE_EXPENSES(state, payload) {
      state.setMonthwiseUsers = payload;
    },
    SET_ALL_USER_TEAM_WISE_EXPENSES(state, payload) {
      state.setOriginalBudget = payload;
    },
    GET_MY_BUDGET_DETAIL(state, payload) {
      state.myBudgetDetail = payload;
    },
    GET_MY_USER_BUDGET_DETAIL(state, payload) {
      state.getmyUserBudget = payload;
    },
    GET_ALL_USER__BUDGET_DETAIL(state, payload) {
      state.getallUserbudget = payload;
    },
    GET_ALL_BUDGET_DETAIL(state, payload) {
      state.allBudgetDetail = payload;
    },
    SET_GROUP_BUDGET_INSERT(state, payload) {
      state.groupBudgetCreated = payload;
    },
    SET_GROUP_BUDGET_UPDATE(state, payload) {
      state.groupBudgetUpdated = payload;
    },
    SET_EMPLOYEEBUDGET_INSERT(state, payload) {
      state.userBudgetCreated = payload;
    },
    SET_EMPLOYEEBUDGET_UPDATE(state, payload) {
      state.userBudgetUpdated = payload;
    },
    SET_EMPLOYEE_REMOVE_FROM_CATEGORY(state, payload) {
      state.removedUserFromCategory = payload;
    },
    SET_CATEGORY_INSERT(state, payload) {
      state.categoryCreated = payload;
    },
    SET_CATEGORY_UPDATE(state, payload) {
      state.categoryUpdated = payload;
    },
    SET_GROUP_BUDGET_LIST(state, payload) {
      state.groupBudgetList = payload;
    },
    SET_GROUP_BUDGET_LIST_TIME(state, payload) {
      state.groupBudgetListTime = payload;
    },
    SET_CURRENT_MONTH_GROUP_BUDGET(state, payload) {
      state.currentMonthGroupBudget = payload;
    },
    SET_CURRENT_MONTH_CATEGORY_BUDGET(state, payload) {
      state.currentMonthCategoryBudget = payload;
    },
    SET_CATEGORY_BUDGET_INSERT_EDIT_CASE(state, payload) {
      state.categoryBudgetForEditcaseCreated = payload;
    },
    SET_CURRENT_MONTH_USER_BUDGET(state, payload) {
      state.currentMonthUserBudget = payload;
    },
    SET_USER_BUDGET_INSERT_EDIT_CASE(state, payload) {
      state.userBudgetForEditcaseCreated = payload;
    },
    SET_BUDGET_REQUEST_INSERT(state, payload) {
      state.requestMoreBudgetCreated = payload;
    },
    SET_ACTIVATE_USER(state, payload) {
      state.userActivated = payload;
    },
    SET_GROUP_ALLOCATED_BUDGET_LIST(state, payload) {
      state.getAllocatedGroupBudget = payload;
    },
    SET_USER_ALLOCATED_BUDGET_LIST(state, payload) {
      state.getUserAllocatedBudget = payload;
    },
    SET_USER_CATEGORY_BUDGET_LIST(state, payload) {
      state.userCategoryBudget = payload;
    },
    GET_GROUP_ALLOCATED_BUDGET(state, payload) {
      state.groupAllocateBudget = payload;
    },
    SET_TEAM_USER_LIST(state, payload) {
      state.teamWiseUserList = payload;
    },
    SET_USER_CALCULATION(state, payload) {
      state.userWiseBudgetAllocation = payload;
    },
    SET_USER_CALCULATION_TIME(state, payload) {
      state.userWiseBudgetAllocationTime = payload;
    },
    SET_COMPNEY_CALCULATION(state, payload) {
      state.compneyCredit = payload;
    },
    SET_CATEGORYNAME(state, payload) {
      state.isCategoryNameSet = payload;
    },
    SET_TEAMNAME(state, payload) {
      state.isTeamNameSet = payload;
    },
    SET_COMPANY_CATEGORIES(state, payload) {
      state.companyCategoryList = payload;
    },
    SET_COMPANY_CATEGORY(state, payload) {
      state.companyCategoriesid = payload;
    },
    SET_USER_ALL_TEAM(state, payload) {
      state.setAllTeamUser = payload;
    },
  },

  actions: {

    getGroupAllocatedBudgetList({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .query({
          query: GET_USER_GROUP_CATEGORIES_GQL,
          variables: payload,
        })
        .then((getGroupAllocatedBudgetListData) => {
          const budgetAllocate = [];
          let budgetAmount = 0;
          getGroupAllocatedBudgetListData.data.groups[0].categories.forEach((category) => {
            category.categorybudgets.forEach((catAmount) => {
              budgetAmount += catAmount.amount;
            });
          });
          budgetAllocate[0] = budgetAmount;
          budgetAllocate[1] = getGroupAllocatedBudgetListData.data.groups[0].groupbudgets[0].amount - budgetAmount;
          commit('SET_GROUP_ALLOCATED_BUDGET_LIST', budgetAllocate);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getGroupAllocatedBudgetListDataErr) => {
          console.log('getGroupAllocatedBudgetListDataErr', getGroupAllocatedBudgetListDataErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Gets Group list with budget information for budget landing page.
    getGroupBudgetList({ commit }, payload) {
      commit('shared/SET_LOADING', true, { root: true });

      const prevYear = payload.year - 1;
      const queryVariable = GET_GROUP_BUDGET_LIST_GQL;

      apolloClient
        .query({
          query: queryVariable,
          variables: {
            month: payload.month,
            year: payload.year,
            prevYear,
            loggedinUserId: payload.loggedinUserId,
          },
          fetchPolicy: 'network-only',
        })
        .then((
          getGroupBudgetListData,
        ) => {
          getGroupBudgetListData.data.date = Date.now();


          commit('SET_GROUP_BUDGET_LIST', getGroupBudgetListData.data.users[0].teams);
          commit('SET_GROUP_BUDGET_LIST_TIME', Date.now());
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getGroupBudgetListDataErr) => {
          console.log('getGroupBudgetListDataErr', getGroupBudgetListDataErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getBudgetDetailForCurrentMonth({ commit }, payload) {
      const promises = [];
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      let queryVariable;
      if (payload.budgetType === 'My Budget') {
        queryVariable = GET_MY_BUDGET_DETAIL_FOR_CURRENTMONTH_GQL;
      } else {
        queryVariable = GET_ALL_BUDGET_DETAIL_FOR_CURRENTMONTH_GQL;
      }
      const prevYear = payload.year - 1;
      apolloClient
        .query({
          query: queryVariable,
          variables: {
            id: payload.groupId,
            month: payload.month,
            year: payload.year,
            prevYear,
            loggedinUserId: payload.loggedinUserId,
            companyId: payload.companyId,
          },
          fetchPolicy: 'network-only',
        })
        .then((getBudgetDetailForCurrentMonthData) => {
          const { data } = getBudgetDetailForCurrentMonthData;
          const groupInfoBudget = {};
          let groupUsedBudget = 0;
          groupInfoBudget.groupId = data.group.id;
          groupInfoBudget.groupName = data.group.groupName;
          if (payload.budgetType !== 'My Budget') {
            groupInfoBudget.users = data.group.users;
            if (data.group.groupbudgets.length > 0) {
              groupInfoBudget.budgetId = data.group.groupbudgets[0].id;
              groupInfoBudget.budgetAllocated = data.group.groupbudgets[0].amount;
            } else {
              groupInfoBudget.budgetId = '';
              groupInfoBudget.budgetAllocated = 0;
            }
          }
          groupInfoBudget.categories = [];
          data.group.categories.forEach((category) => {
            const budgetCategory = {};
            budgetCategory.id = category.id;
            budgetCategory.categoryName = category.categoryName;
            if (category.categorybudgets.length > 0) {
              budgetCategory.budgetId = category.categorybudgets[0].id;
              budgetCategory.budgetAllocated = category.categorybudgets[0].amount;
              groupUsedBudget += budgetCategory.budgetAllocated;
            } else {
              budgetCategory.budgetAllocated = 0;
              budgetCategory.budgetId = '';
            }
            budgetCategory.users = [];
            category.users.forEach((user) => {
              const categoryUser = {};
              categoryUser.id = user.id;
              categoryUser.userPhoto = user.userPhoto;
              categoryUser.email = user.email;

              // const myTeam = user.teams.filter((team) => { team.companyId === this.me.currentCompUserSettings[0].companyId; });
              // console.log('categoryUser', myTeam);

              if (user.teams.length) {
                categoryUser.role = user.teams[0].role.roleName;
              } else {
                categoryUser.role = 'Employee';
              }


              categoryUser.name = `${user.firstName} ${user.lastName}`;
              promises.push(
                apolloClient
                  .query({
                    query: GET_USER_BUDGET_FOR_CURRENTMONTH_GQL,
                    variables: {
                      user: user.id,
                      categoryId: category.id,
                      month: payload.month,
                      year: payload.year,
                      prevYear,
                    },
                    fetchPolicy: 'network-only',
                  })
                  .then((userBudggetForCurrentMonthData) => {
                    if (userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.id !== 0) {
                      if (
                        (payload.month === userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.month
                        && payload.year === userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.year
                        && userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.isDelete === true)
                      || userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.isDelete === false
                      ) {
                        if (
                          payload.month === userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.month
                        && payload.year === userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.year
                        && userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.isDelete === true
                        ) {
                          categoryUser.hideElementsForInactiveUser = true;
                        } else {
                          categoryUser.hideElementsForInactiveUser = false;
                        }
                        if (payload.budgetType === 'My Budget') {
                          categoryUser.remainingBalance = 0;
                          categoryUser.remainingBalance = userBudggetForCurrentMonthData.data
                            .userbudgetsforcurrentmonth.Balance;
                          categoryUser.spentAmount = userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth
                            .amount
                          - categoryUser.remainingBalance;
                        }
                        categoryUser.budgetId = userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.id;
                        categoryUser.budgetAmount = userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth
                          .amount;
                        categoryUser.activeBalance = userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth
                          .activeBalance;
                        categoryUser.note = userBudggetForCurrentMonthData.data.userbudgetsforcurrentmonth.note;
                        budgetCategory.users.push(categoryUser);
                      }
                    }
                  }),
              );
            });
            groupInfoBudget.categories.push(budgetCategory);
          });
          groupInfoBudget.usedGroupBudget = groupUsedBudget;
          groupInfoBudget.remainingGroupBudget = groupInfoBudget.budgetAllocated
            - groupUsedBudget;
          Promise.all(promises).then(() => {
            if (payload.budgetType === 'My Budget') {
              commit('GET_MY_BUDGET_DETAIL', groupInfoBudget);
            } else {
              commit('GET_ALL_BUDGET_DETAIL', groupInfoBudget);
            }
            commit('shared/SET_LOADING', false, {
              root: true,
            });
          });
        })
        .catch((err) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(err);
        });
    },

    requestMoreBudget({ commit }, payload) {
      payload.token = 'Request From Web';
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: REQUEST_MORE_BUDGET_GQL,
          variables: payload,
        })
        .then((requestMoreBudgetData) => {
          commit('SET_BUDGET_REQUEST_INSERT', requestMoreBudgetData.data.createBudgetrequest);
          commit('shared/SET_LOADING', false, { root: true });
        })
        .catch((requestMoreBudgetDataErr) => {
          commit('shared/SET_LOADING', false, { root: true });
          console.log('requestMoreBudgetDataErr', requestMoreBudgetDataErr);
        });
    },
    // Creates group budget
    createGroupBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: GROUP_BUDGET_INSERT_GQL,
          variables: payload,
        })
        .then((createGroupBudgetData) => {
          commit('SET_GROUP_BUDGET_INSERT', createGroupBudgetData.data.createGroupbudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createGroupBudgetErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log('createGroupBudgetErr', createGroupBudgetErr);
        });
    },
    // Checks whether provided month entry is already there in group budget table.
    checkCurrentMonthGroupBudget({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: CHECK_CURRENT_MONTH_GROUP_BUDGET_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((checkCurrentMonthGroupBudgetData) => {
          commit('SET_CURRENT_MONTH_GROUP_BUDGET', checkCurrentMonthGroupBudgetData.data.groupbudgets);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(({ checkCurrentMonthGroupBudgetErr }) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log('checkCurrentMonthGroupBudgetErr', checkCurrentMonthGroupBudgetErr);
        });
    },
    // Checks whether provided month entry is already there in category budget table.
    checkCurrentMonthCategoryBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: CHECK_CURRENT_MONTH_CATEGORY_BUDGET_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((checkCurrentMonthCategoryBudgetData) => {
          commit('SET_CURRENT_MONTH_CATEGORY_BUDGET', checkCurrentMonthCategoryBudgetData.data.categorybudgets);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((checkCurrentMonthCategoryBudgetErr) => {
          console.log('checkCurrentMonthCategoryBudgetErr', checkCurrentMonthCategoryBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Checks whether provided month entry is already there in user budget table.
    checkCurrentMonthUserBudget({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: CHECK_CURRENT_MONTH_USER_BUDGET_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((checkCurrentMonthUserBudgetData) => {
          commit('SET_CURRENT_MONTH_USER_BUDGET', checkCurrentMonthUserBudgetData.data.userbudgets);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(({ checkCurrentMonthUserBudgetErr }) => {
          console.log('checkCurrentMonthUserBudgetErr', checkCurrentMonthUserBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Updates group budget
    updateGroupBudget({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: GROUP_BUDGET_UPDATE_GQL,
          variables: payload,
        })
        .then((updateGroupBudgetData) => {
          commit('SET_GROUP_BUDGET_UPDATE', updateGroupBudgetData.data.updateGroupbudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((updateGroupBudgetErr) => {
          console.log('updateGroupBudget', updateGroupBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // Creates group budget
    createUserbudget({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: EMPLOYEE_TO_CATEGORY_GQL,
          variables: payload,
        })
        .then(() => {
          apolloClient
            .query({
              query: GET_USER_LEDGER_BALANCE_GQL,
              variables: payload,
            })
            .then((ledBalData) => {
              payload.totalBalance = ledBalData.data.ledgerBalances.totalBalance + payload
                .amount;
              payload.Balance = ledBalData.data.ledgerBalances.Balance + payload.amount;
              payload.case = 'Add';
              apolloClient
                .mutate({
                  mutation: EMPLOYEEBUDGET_INSERT_GQL,
                  variables: payload,
                })
                .then((createUserbudgetData) => {
                  commit('SET_EMPLOYEEBUDGET_INSERT', createUserbudgetData.data.createUserbudget);
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                })
                .catch((createUserbudgetErr) => {
                  commit('shared/SET_LOADING', false, {
                    root: true,
                  });
                  console.log(createUserbudgetErr);
                })
                .catch(() => {
                  // Defualt
                });
            });
        })
        .catch((userCreateBudgetErr) => {
          console.log(userCreateBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    activateUser({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.case = 'Activateuser';
      apolloClient
        .mutate({
          mutation: ACTIVATE_USER_GQL,
          variables: payload,
        })
        .then((activateUserData) => {
          commit('SET_ACTIVATE_USER', activateUserData.data.updateUserbudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((activateUserErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(activateUserErr);
        });
    },
    // Creates user budget
    updateUserBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USER_LEDGER_BALANCE_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((ledBalData) => {
          payload.totalBalance = ledBalData.data.ledgerBalances.totalBalance + payload.amountDiff;
          payload.Balance = ledBalData.data.ledgerBalances.Balance + payload.amountDiff;

          payload.case = 'Update';
          apolloClient
            .mutate({
              mutation: EMPLOYEEBUDGET_UPDATE_GQL,
              variables: payload,
            })
            .then((updateUserBudgetData) => {
              commit('SET_EMPLOYEEBUDGET_UPDATE', updateUserBudgetData.data.updateUserbudget);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch(({ updateUserBudgetErr }) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(updateUserBudgetErr);
            });
        });
    },

    removeUserFromCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.case = 'Remove';
      apolloClient
        .mutate({
          mutation: EMPLOYEEBUDGET_DELETE_GQL,
          variables: payload,
        })
        .then((removeUserFromCategoryData) => {
          // Response from server
          commit('SET_EMPLOYEE_REMOVE_FROM_CATEGORY', removeUserFromCategoryData.data.updateUserbudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((removeUserFromCategoryErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(removeUserFromCategoryErr);
        });
    },

    createCompanyCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      apolloClient
        .mutate({
          mutation: CATEGORY_COMPANY_INSERT_GQL,
          variables: payload,
        })
        .then((createCompanyCategoryData) => {
          commit('SET_COMPANY_CATEGORY', createCompanyCategoryData);
        })
        .catch((createCompanyCategoryErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createCompanyCategoryErr);
        });
    },

    // Create category and also make entry in category budget table
    createCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: CATEGORY_INSERT_GQL,
          variables: payload,
        })
        .then((createCategoryData) => {
          payload.categoryId = createCategoryData.data.createCategory.id;

          apolloClient
            .mutate({
              mutation: CATEGORY_BUDGET_INSERT_GQL,
              variables: payload,
            })
            .then((budgetInsertData) => {
              commit('SET_CATEGORY_INSERT', budgetInsertData.data.createCategorybudget);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch((budgetInsertErr) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(budgetInsertErr);
            });
        })
        .catch((createCategoryErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createCategoryErr);
        });
    },
    // Update category and also make update amount in category budget table
    updateCategory({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: CATEGORY_UPDATE_GQL,
          variables: payload,
        })
        .then(() => {
          apolloClient
            .mutate({
              mutation: CATEGORY_BUDGET_UPDATE_GQL,
              variables: payload,
            })
            .then((updateCategoryData) => {
              const updateValue = updateCategoryData.data.updateCategorybudget;
              updateValue.time = new Date();
              commit('SET_CATEGORY_UPDATE', updateValue);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            })
            .catch(({ updateCategoryErr }) => {
              commit('shared/SET_LOADING', false, {
                root: true,
              });
              console.log(updateCategoryErr);
            });
        })
        .catch(({ updateCategoryDataErr }) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log('updateCategoryDataErr', updateCategoryDataErr);
        });
    },
    // Makes entry in category budget for case like entry should be made in table if carry
    // forwarded entry is edited first time.
    createCategoryBudgetForEditcase({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: CATEGORY_BUDGET_INSERT_GQL,
          variables: payload,
        })
        .then((createCategoryBudgetForEditcaseData) => {
          commit('SET_CATEGORY_BUDGET_INSERT_EDIT_CASE', createCategoryBudgetForEditcaseData.data.createCategorybudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createCategoryBudgetForEditcaseErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createCategoryBudgetForEditcaseErr);
        });
    },
    // Makes entry in user budget for case like entry should be made in table if carry
    // forwarded entry is edited first time.
    createUserBudgetForEditcase({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      payload.case = 'Edit';
      apolloClient
        .mutate({
          mutation: EMPLOYEEBUDGET_INSERT_GQL,
          variables: payload,
        })
        .then((createUserBudgetForEditcaseData) => {
          commit('SET_USER_BUDGET_INSERT_EDIT_CASE', createUserBudgetForEditcaseData.data.createUserbudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((createUserBudgetForEditcaseDataErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(createUserBudgetForEditcaseDataErr);
        });
    },

    async getTeamUsers({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_TEAM_USERS_GQL,
          variables: payload,
        })
        .then((getTeamUsersData) => {
          commit('SET_TEAM_USER_LIST', getTeamUsersData.data);
        })
        .catch((getTeamUsersErr) => {
          console.log(getTeamUsersErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // JPEdited
    async getUserCalculation({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_USERS_CALCULATION_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getUserCalculationData) => {
          commit('SET_USER_CALCULATION_TIME', new Date());
          commit('SET_USER_CALCULATION', getUserCalculationData.data.userBudgetCalculation);
        })
        .catch((getUserCalculationErr) => {
          console.log(getUserCalculationErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getCompniesBudget({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_COMPANY_CALCULATION_GQL,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getCompniesBudgetData) => {
          const x = getCompniesBudgetData.data.companiesTotalCredit;
          commit('SET_COMPNEY_CALCULATION', x);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getCompniesBudgetErr) => {
          console.log(getCompniesBudgetErr);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });
    },
    // makeChangeCategory
    async makeChangeCategory({ commit }, payload) {
      await apolloClient
        .mutate({
          mutation: SET_CATEGORY_NAME_GQL,
          variables: payload,
        })
        .then((makeChangeCategoryata) => {
          commit('SET_CATEGORYNAME', makeChangeCategoryata.data);
        })
        .catch((makeChangeCategoryataErr) => {
          console.log(makeChangeCategoryataErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    async getCompanyCategory({ commit }, payload) {
      await apolloClient
        .query({
          query: GET_COMPANY_CATEGORY_LIST_GQL,
          variables: payload,
          fetchPolicy: 'no-cache',
        })
        .then((getCompanyCategoryData) => {
          commit('SET_COMPANY_CATEGORIES', getCompanyCategoryData.data.companyCategories);
        })
        .catch((err) => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    updateComponyBudget({ commit }, payload) {
      apolloClient
        .query({
          query: GET_COMPANY_BUDGET,
          variables: payload,
        })
        .then((updateComponyBudgetData) => {
          const diffValue = updateComponyBudgetData.data.company.currentBudget + payload.diff;


          // TEST
          apolloClient
            .mutate({
              mutation: UPDATE_COMPANY_BUDGET,
              variables: {
                id: payload.id,
                currentBudget: diffValue,
              },
            })
            .then(() => {
              // Compony Budget updated
              // Nothing Return
              // console.log(dataOne);
            })
            .catch((budgetUpdateErr) => {
              console.log(budgetUpdateErr);
              commit('shared/SET_LOADING', false, {
                root: true,
              });
            });
          // END
        })
        .catch((updateComponyBudgetErr) => {
          console.log('updateComponyBudgetErr', updateComponyBudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    updateUserDefinebudget({ commit }, payload) {
      // TEST
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_USERDEFINE_BUDGET,
          variables: {
            ...payload,
          },
        })
        .then((updateUserDefinebudgetData) => {
          commit('SET_COMPNEY_CALCULATION', updateUserDefinebudgetData.data.updateUserDefinebudget);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((updateUserDefinebudgetErr) => {
          console.log(updateUserDefinebudgetErr);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    // get  user original Budget
    getOriginalUserBudget({ commit }, payload) {
      commit('shared/SET_LOADING_CHILD', true, {
        root: true,
      });
      apolloClient
        .query({
          query: GET_USER_ACTUAL_BUDGET,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((getOriginalUserBudgetData) => {
          // eslint-disable-next-line max-len
          const teamWiseData = getOriginalUserBudgetData.data.userAvailableBudget.sort((a, b) => a.firstName.localeCompare(b.firstName));
          commit('SET_ALL_USER_TEAM_WISE_EXPENSES', { Date: new Date(), teamWiseData });

          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        })
        .catch((getOriginalUserBudgetDataErr) => {
          console.log(getOriginalUserBudgetDataErr);
          commit('shared/SET_LOADING_CHILD', false, {
            root: true,
          });
        });
    },
    // get User for from list
    async getTeamUser({
      commit,
    }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });

      await apolloClient
        .query({
          query: GET_TEAM_USER,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then((getTeamUserData) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_USER_ALL_TEAM', getTeamUserData.data.getTeamUsers);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamUserDataErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getTeamUserDataErr);
        });
    },

    // Get Monthwise
    async getTeamwiseUserExpense({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      await apolloClient
        .query({
          query: GET_TEAM_WISE_EXPENSE_USER,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then((getTeamwiseUserExpenseData) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          const teamWiseData = getTeamwiseUserExpenseData.data.userBudgetMonthly.sort((a, b) => a.name.localeCompare(b.name));
          commit('SET_USER_TEAM_WISE_EXPENSES', { teamWiseData, time: new Date() });
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getTeamwiseUserExpenseErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getTeamwiseUserExpenseErr);
        });
    },

    async getUserdefineBudget({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
  
      // Skip API call and return empty data if bulk transactions is enabled
      if (isBulkTransactionsEnabled()) {
        console.log('Bulk Transactions: Skipping getUserdefineBudget API call');
        // Return empty budget data with zeros
        commit('SET_USER_DEFINE_BUDGET', {
          allocated: 0,
          expense: 0,
          available: 0
        });
        commit('shared/SET_LOADING', false, { root: true });
        return;
      }
  
      await apolloClient
        .query({
          query: GET_USER_DEFINE_BUDGET,
          variables: {
            ...payload,
          },
          fetchPolicy: 'network-only',
        })
        .then((getUserdefineBudgetData) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });
          commit('SET_USER_DEFINE_BUDGET', getUserdefineBudgetData.data.getCompanyCreditLimit);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((getUserdefineBudgetErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(getUserdefineBudgetErr);
        });
    },

    async activeDeactiveCategory({ commit }, payload) {
      await apolloClient
        .query({
          query: UPDATE_CATEGORY_STATUS,
          variables: payload,
          fetchPolicy: 'network-only',
        })
        .then((activeDeactiveCategoryData) => {
          commit('shared/SET_LOADING', true, {
            root: true,
          });

          commit('SET_CATEGORY_STATUS', activeDeactiveCategoryData.data.updateCategoryStatus);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch((activeDeactiveCategoryErr) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log(activeDeactiveCategoryErr);
        });
    },

  },
  getters: {
    myBudgetDetail: state => state.myBudgetDetail,
    allBudgetDetail: state => state.allBudgetDetail,
    groupBudgetCreated: state => state.groupBudgetCreated,
    groupBudgetUpdated: state => state.groupBudgetUpdated,
    userBudgetCreated: state => state.userBudgetCreated,
    userBudgetUpdated: state => state.userBudgetUpdated,
    removedUserFromCategory: state => state.removedUserFromCategory,
    categoryBudgetCreated: state => state.categoryBudgetCreated,
    categoryBudgetUpdated: state => state.categoryBudgetUpdated,
    categoryCreated: state => state.categoryCreated,
    categoryUpdated: state => state.categoryUpdated,
    groupBudgetList: state => state.groupBudgetList,
    groupBudgetListTime: state => state.groupBudgetListTime,
    currentMonthGroupBudget: state => state.currentMonthGroupBudget,
    currentMonthCategoryBudget: state => state.currentMonthCategoryBudget,
    categoryBudgetForEditcaseCreated: state => state.categoryBudgetForEditcaseCreated,
    currentMonthUserBudget: state => state.currentMonthUserBudget,
    userBudgetForEditcaseCreated: state => state.userBudgetForEditcaseCreated,
    requestMoreBudgetCreated: state => state.requestMoreBudgetCreated,
    userActivated: state => state.userActivated,
    getAllocatedGroupBudget: state => state.getAllocatedGroupBudget,
    getUserAllocatedBudget: state => state.getUserAllocatedBudget,
    userCategoryBudget: state => state.userCategoryBudget,
    getallUserbudget: state => state.getallUserbudget,
    getmyUserbudget: state => state.getmyUserBudget,
    groupAllocateBudget: state => state.groupAllocateBudget,
    teamWiseUserList: state => state.teamWiseUserList,
    userWiseBudgetAllocation: state => state.userWiseBudgetAllocation,
    compneyCredit: state => state.compneyCredit,
    isCategoryNameSet: state => state.isCategoryNameSet,
    isTeamNameSet: state => state.isTeamNameSet,
    userWiseBudgetAllocationTime: state => state.userWiseBudgetAllocationTime,
    companyCategoryList: state => state.companyCategoryList,
    companyCategoriesid: state => state.companyCategoriesid,
    setAllTeamUser: state => state.setAllTeamUser,
    setMonthwiseUsers: state => state.setMonthwiseUsers,
    setOriginalBudget: state => state.setOriginalBudget,
    userDefineBudget: state => state.userDefineBudget,
    setCategoryStatus: state => state.setCategoryStatus,
  },
};
